import { FunctionComponent, ReactNode, TdHTMLAttributes } from 'react';
import cn from '../cn';

type TableCellUIProps = {
  align?: 'left' | 'center' | 'right' | 'justify' | 'inherit',
  // `.ds-table tbody td` is `white-space: nowrap` by default so many-column
  // operational tables stay dense. Most call sites are small tables where that
  // just forces a horizontal scroll for a single long value, so wrapping is
  // opted-in here by default via `[data-ds-wrap="true"]`. Pass `wrap={false}`
  // on a dense table where nowrap is desirable.
  wrap?: boolean,
  children?: ReactNode,
} & Omit<TdHTMLAttributes<HTMLTableCellElement>, 'align'>;

// Body cell. Appearance (padding, height, borders, colour) comes from
// `.ds-table tbody td` so it matches the component gallery exactly; this only
// adds alignment and whatever the call site passes.
const TableCellUI: FunctionComponent<TableCellUIProps> = ({ align = 'left', wrap = true, className = '', children, ...rest }) => (
  <td
    data-ds-wrap={wrap ? 'true' : undefined}
    className={cn(
      align === 'center' && 'text-center',
      align === 'right' && 'text-right',
      align === 'justify' && 'text-justify',
      className,
    )}
    {...rest}
  >
    {children}
  </td>
);

export default TableCellUI;
